<template>
  <div id="body-content">
    <Hero id="section-1" cta="https://www.credit-agricole.fr/particulier/form-demande-rdv.html" />
    <Avantages id="section-2" cta="https://www.credit-agricole.fr/particulier/form-demande-rdv.html" />
    <Quiz id="section-3" cta="https://www.credit-agricole.fr/particulier/form-demande-rdv.html" />
    <Informations id="section-4" cta="https://www.credit-agricole.fr/particulier/form-demande-rdv.html" />
  </div>
</template>

<script>
import Hero from './components/Hero'
import Avantages from './components/Avantages'
import Quiz from './components/Quiz'
import Informations from './components/Informations'

export default {
  name: 'App',
  components: {
    Hero,
    Avantages,
    Quiz,
    Informations
  }
}
</script>

<style lang="scss">
  @import "./assets/style";

  #footer_tc_privacy_text p {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue